import { render } from "./PlatformSessionsRules.vue?vue&type=template&id=21950b02"
import script from "./PlatformSessionsRules.vue?vue&type=script&lang=js"
export * from "./PlatformSessionsRules.vue?vue&type=script&lang=js"

import "./PlatformSessionsRules.vue?vue&type=style&index=0&id=21950b02&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__